import 'jquery';

import { runInnerFunction } from "../../compatManager";
import { FormatDateDataType } from "../../util/genericDateAndTimeFuncs";

export namespace PIPFormClient {
    export interface Purchaser {
        EntityType: number;
        FirstName?: string;
        MiddleNames?: string;
        LastName?: string;
        Name?: string;
        NonResident?: number;
        BirthDate?: string;
    }
    export interface Lawyer {
        Name: string;
        Email?: string;
    }
    export interface Property {
        PINBlock: string;
        PINProperty: string;
        Type?: string;
    }
    export interface PIPInfo {
        Purchasers: Array<Purchaser>;
        Lawyer: Lawyer;
        Properties: Array<Property>;
        resideOnProperty: number;
    }
    export interface PdfGenerationConfig {
        contentWidth: number;
        contentHeight: number;
        xOffset: number;
        yOffset: number;
    }    
    function ParseFullName(fullname: string): Array<string> {
        let arrNames = ["", "", ""];	//first, middle, last
        if (!(fullname > ''))	//nothing to parse
            return arrNames;

        //now let's parse
        let surname = "", givennames = "";
        let posComa = fullname.indexOf(",");
        if (posComa != -1) {
            surname = fullname.substring(0, posComa);
            givennames = fullname.substring(posComa + 1);
        }
        else {
            let posSpace = fullname.lastIndexOf(" ");
            if (posSpace != -1) {
                givennames = fullname.substring(0, posSpace);
                surname = fullname.substring(posSpace + 1);
            }
            else {
                surname = "";
                givennames = fullname;	//not even a proper name, like people from Mongolia
            }
        }
        arrNames[2] = (surname).trim();
        let fn = "", mn = "";
        givennames = (givennames).trim();
        givennames = givennames.replace(/ {2}/g, " ");
        let arrgivennames = givennames.split(" ");
        for (let i = 0; i < arrgivennames.length; i++) {
            let onename = (arrgivennames[i]).trim();
            if (fn == "")
                fn = onename;
            else {
                if (mn != "")
                    mn += " ";
                mn += onename;
            }
        }
        arrNames[0] = fn;
        arrNames[1] = mn;

        return arrNames;
    }


    export function ConvertOldTPAppXML(data: any): PIPInfo {
        let info: PIPInfo = { Purchasers: [], Properties: [], Lawyer: { Name: data.getAttribute('LawyerName'), Email: runInnerFunction('ReactShell.reactXMLRunPath','lawyer/@FirmEmail')}, resideOnProperty: data.getAttribute('ResideAtProperty') };
        let purs = data.selectNodes(`Purchaser[@OnTitle='1' and not(not(@TransfereeNameFull)) and not(@TransfereeNameFull='')]`);
        if (purs) {
            for (let i = 0; i < purs.length; i++) {
                let pur = purs[i];
                let g = pur.getAttribute('Gender');
                let name = pur.getAttribute('TransfereeNameFull');
                if (g === "Corporation")
                    info.Purchasers.push({ EntityType: 1, Name: name });
                else {
                    let names = ParseFullName(name);
                    let dateString = `${FormatDateDataType(pur.getAttribute('BirthDate'), 'df11')}` ;
                    info.Purchasers.push({ EntityType: 0, FirstName: names[0], MiddleNames: names[1], LastName: names[2], BirthDate: dateString });
                }
            }
        }
        let pins: any = null;
        if (data.getAttribute('PropertyType') === 'Condo')
            pins = data.selectNodes(`LegalDescriptionInput/Unit[@Type='Dwelling' and @PINBlock and @PINProperty]`)
        else
            pins = data.selectNodes('LegalDescriptionInput/Lot/LotPIN[@PINBlock and @PINProperty]')
        if (pins) {
            for (let i = 0; i < pins.length; i++) {
                let pin = pins[i];
                info.Properties.push({ PINBlock: pin.getAttribute('PINBlock'), PINProperty: pin.getAttribute('PINProperty') });
            }
        }
        // should we use staff info instead ??
        let staffName = runInnerFunction('ReactShell.reactXMLRunPath',"Staff/@Name");
        if (staffName > '') {
            info.Lawyer.Name = staffName;
        }
        let staffEmail = runInnerFunction('ReactShell.reactXMLRunPath',"Staff/MiscContact[@ContactMethod='Email']/@ContactMethodInfo");
        if (staffEmail > '') {
            info.Lawyer.Email = staffEmail;
        }
        return info;

    }

    function s2f(s: string): string {
        if (s > '')
            return encodeURIComponent(s);
        else
            return '';
    }
    function n2bt(ind: any, rev = false): string {
        let t = rev ? "false" : "true";
        let f = rev ? "true" : "false";
        if (ind == 0)
            return f;
        else if (ind == 1)
            return t;
        else
            return '';
    }
    function convertDate(s: string): string {
        if (s > '') {
            s = s.replace(/\-/g, '/');
        }
        return s2f(s);

    }
    export async function CreateNewForm(info: PIPInfo): Promise<string> {
        let formData = `event=SaveWIP&eventData=&eventData2=&wipFormId=&lockVersion=`;
        for (let i = 0; i < info.Properties.length; i++) {
            let ptype = '1,Single family residence';
            let p = info.Properties[i];
            formData += `&properties%5B${i}%5D.hasPrincipleResidence=${n2bt(info.resideOnProperty)}&properties%5B${i}%5D.pinPrefix=${p.PINBlock}&properties%5B${i}%5D.pinSuffix=${p.PINProperty}&properties%5B${i}%5D.isRentOut=${n2bt(info.resideOnProperty, true)}&properties%5B${i}%5D.propertyType=${s2f(ptype)}&properties%5B${i}%5D.dwellingType=`;
        }
        for (let j = 0, corpid = 0, personid = 0; j < info.Purchasers.length; j++) {
            let pur = info.Purchasers[j];
            let i: number;
            if (pur.EntityType === 1) {
                i = corpid++;
                formData += `&corporations%5B${i}%5D.corporationName=${s2f(pur.Name)}&corporations%5B${i}%5D.numberOfDirector=&corporations%5B${i}%5D.numberOfNonResidentDirector=&_corporations%5B${i}%5D.directorCountries=1&corporations%5B${i}%5D.shareOfNonResidentShareholder=&corporations%5B${i}%5D.shareholderCountryType=&corporations%5B${i}%5D.shareholderOtherCountry=&corporations%5B${i}%5D.shareholderProportion=&_corporations%5B${i}%5D.shareholderCountries=1&_corporations%5B${i}%5D.isTrustee=on&=`;
                formData += `&corporations%5B${i}%5D.isForeignCorp=`;
            }
            else {
                i = personid++;
                formData += `&individuals%5B${i}%5D.firstName=${s2f(pur.FirstName)}&individuals%5B${i}%5D.middleName=${s2f(pur.MiddleNames)}&individuals%5B${i}%5D.lastName=${s2f(pur.LastName)}&individuals%5B${i}%5D.dateOfBirth=${convertDate(pur.BirthDate)}&individuals%5B${i}%5D.isInCanada=${n2bt(pur.NonResident, true)}&individuals%5B${i}%5D.isResidentOfCanada=${n2bt(pur.NonResident, true)}&_individuals%5B${i}%5D.countryOfCitizenship=1&individuals%5B${i}%5D.otherCountryOfCitizenship=&_individuals%5B${i}%5D.isTrustee=on`;
            }
        }
        formData += `&_isAcknowledged=on&submitter=${s2f(info.Lawyer.Name)}&email=${info.Lawyer.Email}`;
       
        let iframe = document.getElementById('pipScreen') as HTMLIFrameElement;
        let wobj:any = iframe.contentWindow; 
        if (!wobj.___submitData ) {
            wobj.___submitData = async function () {
                let infoUrl = "/csp/land-transfer-tax-info";
                let submitBody = {
                    body: formData, 
                    headers : {"Content-Type": "application/x-www-form-urlencoded"},
                    method: "POST",
                }
                let submitResponse = await fetch(infoUrl, submitBody)
                let submitText = await submitResponse.text();
                let reg = /(?<=land-transfer-tax-info-wip\?id=)(\w+\d+)/;
                let retArr = reg.exec(submitText);
                if (retArr && retArr[0] > "") {
                    return retArr[0];
                }
                return '';
            }
        }
        var rev = await wobj.eval(`___submitData(\`${formData}\`)`);
        return rev;
    }
}